/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface DeviceFirmwareResponse
 */
export interface DeviceFirmwareResponse {
    /**
     *
     * @type {string}
     * @memberof DeviceFirmwareResponse
     */
    firmwareContainerName?: string;
    /**
     *
     * @type {string}
     * @memberof DeviceFirmwareResponse
     */
    filename?: string;
    /**
     *
     * @type {Date}
     * @memberof DeviceFirmwareResponse
     */
    creationDate?: Date;
    /**
     * Size of firmware in bytes
     * @type {number}
     * @memberof DeviceFirmwareResponse
     */
    size?: number;
    /**
     *
     * @type {string}
     * @memberof DeviceFirmwareResponse
     */
    firmwareNumber?: string;
    /**
     *
     * @type {string}
     * @memberof DeviceFirmwareResponse
     */
    projectName?: string;
    /**
     *
     * @type {string}
     * @memberof DeviceFirmwareResponse
     */
    configNumber?: string;
    /**
     *
     * @type {string}
     * @memberof DeviceFirmwareResponse
     */
    mcuPartNumber?: string;
    /**
     *
     * @type {string}
     * @memberof DeviceFirmwareResponse
     */
    firmwareVersion?: string;
    /**
     *
     * @type {string}
     * @memberof DeviceFirmwareResponse
     */
    fullFirmwareVersion?: string;
    /**
     *
     * @type {string}
     * @memberof DeviceFirmwareResponse
     */
    projectType?: string;
    /**
     *
     * @type {string}
     * @memberof DeviceFirmwareResponse
     */
    status?: DeviceFirmwareResponseStatusEnum;
    /**
     * Explanatory note for any change in status
     * @type {string}
     * @memberof DeviceFirmwareResponse
     */
    notes?: string;
    /**
     * External user Id for the user who made a change in device firmware status
     * @type {string}
     * @memberof DeviceFirmwareResponse
     */
    externalUserId?: string;
    /**
     * List of PCB versions that this firmware is compatible with
     * @type {Array<string>}
     * @memberof DeviceFirmwareResponse
     */
    compatiblePcbVersions?: Array<string>;
    /**
     * List of PCB variants that this firmware is compatible with
     * @type {Array<string>}
     * @memberof DeviceFirmwareResponse
     */
    compatiblePcbVariants?: Array<string>;
}

/**
 * @export
 */
export const DeviceFirmwareResponseStatusEnum = {
    Enabled: "Enabled",
    Disabled: "Disabled",
} as const;
export type DeviceFirmwareResponseStatusEnum =
    (typeof DeviceFirmwareResponseStatusEnum)[keyof typeof DeviceFirmwareResponseStatusEnum];

/**
 * Check if a given object implements the DeviceFirmwareResponse interface.
 */
export function instanceOfDeviceFirmwareResponse(
    value: object,
): value is DeviceFirmwareResponse {
    return true;
}

export function DeviceFirmwareResponseFromJSON(
    json: any,
): DeviceFirmwareResponse {
    return DeviceFirmwareResponseFromJSONTyped(json, false);
}

export function DeviceFirmwareResponseFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): DeviceFirmwareResponse {
    if (json == null) {
        return json;
    }
    return {
        firmwareContainerName:
            json["firmwareContainerName"] == null
                ? undefined
                : json["firmwareContainerName"],
        filename: json["filename"] == null ? undefined : json["filename"],
        creationDate:
            json["creationDate"] == null
                ? undefined
                : new Date(json["creationDate"]),
        size: json["size"] == null ? undefined : json["size"],
        firmwareNumber:
            json["firmwareNumber"] == null ? undefined : json["firmwareNumber"],
        projectName:
            json["projectName"] == null ? undefined : json["projectName"],
        configNumber:
            json["configNumber"] == null ? undefined : json["configNumber"],
        mcuPartNumber:
            json["mcuPartNumber"] == null ? undefined : json["mcuPartNumber"],
        firmwareVersion:
            json["firmwareVersion"] == null
                ? undefined
                : json["firmwareVersion"],
        fullFirmwareVersion:
            json["fullFirmwareVersion"] == null
                ? undefined
                : json["fullFirmwareVersion"],
        projectType:
            json["projectType"] == null ? undefined : json["projectType"],
        status: json["status"] == null ? undefined : json["status"],
        notes: json["notes"] == null ? undefined : json["notes"],
        externalUserId:
            json["externalUserId"] == null ? undefined : json["externalUserId"],
        compatiblePcbVersions:
            json["compatiblePcbVersions"] == null
                ? undefined
                : json["compatiblePcbVersions"],
        compatiblePcbVariants:
            json["compatiblePcbVariants"] == null
                ? undefined
                : json["compatiblePcbVariants"],
    };
}

export function DeviceFirmwareResponseToJSON(
    value?: DeviceFirmwareResponse | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        firmwareContainerName: value["firmwareContainerName"],
        filename: value["filename"],
        creationDate:
            value["creationDate"] == null
                ? undefined
                : value["creationDate"].toISOString(),
        size: value["size"],
        firmwareNumber: value["firmwareNumber"],
        projectName: value["projectName"],
        configNumber: value["configNumber"],
        mcuPartNumber: value["mcuPartNumber"],
        firmwareVersion: value["firmwareVersion"],
        fullFirmwareVersion: value["fullFirmwareVersion"],
        projectType: value["projectType"],
        status: value["status"],
        notes: value["notes"],
        externalUserId: value["externalUserId"],
        compatiblePcbVersions: value["compatiblePcbVersions"],
        compatiblePcbVariants: value["compatiblePcbVariants"],
    };
}
